import { Box, MenuItem } from "@mui/material";
import ThreeDotsMenu from "components/ThreeDots/ThreeDotsMenu";
import { FormattedMessage as T } from "react-intl";

type OrganizationDynamicMenuActionsProps = {
  onView: () => void;
  onUnassign?: () => void;
};

export default function OrganizationDynamicMenuActions({
  onView,
  onUnassign,
}: Readonly<OrganizationDynamicMenuActionsProps>) {
  return (
    <ThreeDotsMenu>
      <MenuItem onClick={onView}>
        <T id="viewMenu" />
      </MenuItem>
      <MenuItem onClick={onUnassign} disabled={!onUnassign}>
        <Box sx={{ color: "error.main" }}>
          <T id="unassignMenu" />
        </Box>
      </MenuItem>
    </ThreeDotsMenu>
  );
}
